<template>
  <div>
      <v-card-text>
        <label>Sublist Name</label>
        <v-text-field
          :id = "`edit-name-${_uid}`"
          v-model="input.name"
          placeholder = "Type Your Sublist Name"
          outline />
        <label>Synonyms</label>
        <v-autocomplete
          :id = "`edit-synonyms-${_uid}`"
          v-model="input.synonyms"
          :items="typeItems"
          placeholder = "Type Your Item Synonyms"
          no-data-text = "Press Enter To Add"
          box
          chips
          multiple
          outline/>
    </v-card-text>
    <v-card-actions>
      <v-spacer/>
      <v-btn color = "primary" @click="updateEntity">Save</v-btn>
    </v-card-actions>
</div>
</template>

<script>
export default {

  name: 'EditSynonyms',
  props: {
    item: {
      type: Object,
      default: null
    }
  },
  data () {
    return {
      input: {
        name: '',
        synonyms: []
      },
      typeItems: [],
      inputTouches: {
        name: false,
        synonyms: false
      }
    }
  },
  mounted() {
    const vm = this
    setTimeout(() => {
      const selector = document.querySelector(`#edit-synonyms-${this._uid}`)
      if (selector)
        selector.addEventListener('keydown', e => {
          window.s = selector
          if (e.keyCode === 13 && selector.value.length && vm.input.synonyms.indexOf(e.target.value) === -1) {
            vm.typeItems.push(e.target.value)
            vm.input.synonyms.push(e.target.value)
            // vm.inputTouches.synonyms = true
            setTimeout(() => {
              selector.value = ''
            }, 100)
          }
        })
    }, 1000)
  },
  watch: {
    item: {
      deep: true,
      immediate: true,
      handler(val) {
        if(val) {
          this.input.name = val.name
          if(val.synonyms && val.synonyms.length) {
            this.typeItems = this.$_.cloneDeep(val.synonyms.map(s => s.name))
            this.input.synonyms = this.$_.cloneDeep(this.typeItems)
          } else {
            this.input.synonyms = []
          }
        } else {
          this.input = {
            name: '',
            synonyms: []
          }
        }
      }
    }
  },
  methods: {
    async updateEntity() {
      this.$store.dispatch('setLoader', true)
      try {
        await this.updateSublistName(this.input.name)
        await this.deleteAllSynonyms()
        await this.addAllSynonyms()
        this.$store.dispatch('setLoader', false)
        this.$emit('success')
        this.$store.dispatch('setSnackbar', {
          text: `Saved`,
          color: 'success'
        })
      } catch (err) {
        this.$store.dispatch('setLoader', false)
        this.$store.dispatch('setErrorMessage', (err && err.response && err.response.data && err.response.data.error) ? err.response.data.error : true)
      }
    },
    async addAllSynonyms() {
      try {
        let i
        for(i = 0; i < this.input.synonyms.length; i += 1) {
          await this.addSynonym(this.input.synonyms[i])
        }
        return true
      } catch(err) {
        throw err
        return false
      }
    },
    async addSynonym(name) {
      try {
          // check if it was already initiated
          if(this.item.synonyms.findIndex(s => s.name === name) !== -1)
            return true
          await this.$http_nlp.post(
            `/apps/${this.$store.state.nlp.selectedApp.id}/entity_synonyms/`,
            { name, entity_sublist: this.item.id }
          )
          return true
        } catch (err) {
          throw err
          return false
        }
    },
    async deleteAllSynonyms() {
      try {
        let i
        for(i = 0; i < this.item.synonyms.length; i += 1) {
          await this.deleteSynonym(this.item.synonyms[i])
        }
        return true
      } catch(err) {
        throw err
        return false
      }
    },
    async deleteSynonym(synonym) {
      try {
          // check if it was not touched
          if(this.input.synonyms.indexOf(synonym.name) !== -1)
            return true
          await this.$http_nlp.delete(
            `/apps/${this.$store.state.nlp.selectedApp.id}/entity_synonyms/${synonym.id}`
          )
          return true
        } catch (err) {
          throw err
          return false
        }
    },
    async updateSublistName(name) {
      try {
          if (this.item.name === name)
            return true
          await this.$http_nlp.put(
            `/apps/${this.$store.state.nlp.selectedApp.id}/entity_sublists/${this.item.id}`,
            { name }
          )
          return true
        } catch (err) {
          throw err
          return false
        }
    },
    handleInputTouch(slug) {
      this.inputTouches[slug] = true
    }
  }
}
</script>

<style lang="css" scoped>
</style>